import React, { useState } from 'react'
import signup from '../Assets/signup.png'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Create_Api } from '../ApiUrls';

function SignUp() {

  const navigate = useNavigate();
  const [IsUploading, setIsUploading] = useState(false);
  const [FirstName, setFirstName] = useState();
  const [LastName, setLastName] = useState();
  const [Email, setEmail] = useState('');
  const [Number, setNumber] = useState();
  const [Password, setPassword] = useState('');


  const UserSignup = async () => {
    if (!Email) {
      toast.error('Email is required!');
      return;
    }
    if (!FirstName) {
      toast.error('FirstName is required!');
      return;
    }
    if (!LastName) {
      toast.error('LastName is required!');
      return;
    }
    if (!Number) {
      toast.error('Number is required!');
      return;
    }
    if (!Password) {
      toast.error('Password is required!');
      return;
    }

    try {
      let data = {
        Email,
        FirstName,
        LastName,
        Number,
        Password
      }
      setIsUploading(true)
      const response = await Create_Api(`api/user/Register`, data)
      console.log('User Login Successfull:', response);
      localStorage.setItem('user', JSON.stringify(response?.data));
      localStorage.setItem('userid', response?.data?.User?._id);
      localStorage.setItem('userToken', response?.data?.token);
      toast.success(response?.message);
      setEmail('')
      setFirstName('')
      setLastName('')
      setNumber('')
      setPassword('')
      navigate('/')
      setIsUploading(false)
    } catch (error) {
      setIsUploading(false)
      toast.error(error?.response?.data?.message);
      console.log(error)
    }
  }



  return (
    <>
      <Navbar />
      <br />
      <div className="login-page">
        <div className="login-header">
          <h1>Sign Up</h1>
          <p>
            Home / <span className="active">Sign Up</span>
          </p>
        </div>

        <div className="login-container">
          <div className="login-image">
            <img src={signup} alt="Login Illustration" />
          </div>
          <div className="login-form">
            <h2>SignUp</h2>
            <p>Sign up to access your ADL Account</p>

            <div className="form-row">
              <div className="form-group">
                <label>First Name</label>
                <input
                  type="text"
                  placeholder="John"
                  required
                  value={FirstName}
                  onChange={(e) => { setFirstName(e.target.value) }}
                />
              </div>
              <div className="form-group">
                <label>Last Name</label>
                <input
                  type="text"
                  placeholder="Doe"
                  value={LastName}
                  onChange={(e) => { setLastName(e.target.value) }}
                  required />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  placeholder="john.doe@gmail.com"
                  value={Email}
                  onChange={(e) => { setEmail(e.target.value) }}
                  required />
              </div>
              <div className="form-group">
                <label>Phone Number</label>
                <input
                  type="number"
                  placeholder="+1234567890"
                  value={Number}
                  onChange={(e) => { setNumber(e.target.value) }}
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                placeholder="*********"
                required
                value={Password}
                onChange={(e) => { setPassword(e.target.value) }}
              />
            </div>

            <div className="form-options">
              <label>
                <input type="checkbox" />
                Remember me
              </label>
              <a href="/forgot-password" className="forgot-password">
                Forgot Password?
              </a>
            </div>

            <button onClick={UserSignup} className="login-btn">
              {IsUploading ? "Please Wait" : "Sign Up"}
            </button>

            <p>
              Already have an account? <a href="/login">Log in</a>
            </p>
          </div>

        </div>
      </div>
      <br />
      <Footer />
    </>
  )
}

export default SignUp